import { FAULU_LOAN_CALCULATOR_FORM_SET_VALUE } from "../../../actions/fauluLoanCalculator/fauluLoanCalculatorForm";
import { fauluLoanCalculatorFormValidation } from "./fauluLoanCalculator";

export const fauluLoanCalculatorValidation = (store, next, action) => {
    if (action.type.startsWith(FAULU_LOAN_CALCULATOR_FORM_SET_VALUE)) {
        return fauluLoanCalculatorFormValidation(store, next, action);
    }
}